import { IPage } from '../../interfaces'
import Table from '../form/Table.tsx'
import { context } from '../../index.js';
import { observer } from 'mobx-react-lite';
import FormFields from '../form/FormFields.tsx';
import TableOpen from '../form/TableOpen.tsx';

interface IPageProps {
    page: IPage;
}

export default observer(function Page ({page}: IPageProps) {

    console.clear()
    console.log("Rerender - " + page.title)
    const description = context.formatLabel(page.description)
    var submitButtonText = context.showSettings ? "Save settings" : "Next"
    if (page.table) {
        submitButtonText = null
    }

    return (
        <div className="questionnaire-page">
            {page.title && !page.hideTitle ? (
                <h2>{context.formatLabel(page.title)}</h2>
            ) : null}

            {description && !description.includes("{") ? <div dangerouslySetInnerHTML={{__html: description}}></div> : null}

            {page.fields ? (
                <FormFields 
                    submitButtonText={submitButtonText}
                    initialValues={{...context.preloadedAnswers, ...context.answers}} 
                    fields={page.fields} 
                    onChange={(formik) => {
                        context.unsubmittedValues = formik.values
                    }}
                    onSubmit={(values) => {
                        context.submitPageAnswers(values)
                    }} />
            ) : null}

            {page.table ? (
                <div>
                    {page.table.style === "open" ? (
                        <TableOpen
                            table={page.table} 
                            onChange={(values) => {
                                context.submitPageAnswers(values, false)
                            }}
                            onSubmit={(values) => {
                                context.submitPageAnswers(values)
                            }} /> 
                    ) : (
                        <Table 
                            table={page.table} 
                            onChange={(values) => {
                                context.submitPageAnswers(values, false)
                            }}
                            onSubmit={(values) => {
                                context.submitPageAnswers(values)
                            }} /> 
                    )}
                </div>
            ) : null}
        </div>
    )
})